import React from 'react'
import { useTranslation } from 'react-i18next'
import PortFolioCards from '../components/PortFolioCards';
import Imagex from '../assets/portfolio/applier.png'
import todo from '../assets/portfolio/todo.png'

const PortFolio = () => {
    const [t] = useTranslation("global");
    return (
        <section className="Portfolio" id='Portfolio'>
            <h1 className='Portfolio_title'>{t("Portfolio")}</h1>
            <div className='Portfolio-container'>
                    <PortFolioCards image={Imagex} link='https://www.iproup.com/innovacion/24918-fichap-se-une-con-applier-para-revolucionar-el-hr-tech-local' title="Applier" paragraph="pph1" color="red"/>
                    <PortFolioCards image={todo} link='https://todoapp-cbc55.web.app/' title="Todo App" paragraph="aplicacion de recordatorios" color="red"/>
            </div>
        </section>
    )
}

export default PortFolio
